
import { TranslationRecord } from '../../types';

export const navigation: TranslationRecord = {
  // Navigation
  home: 'Home',
  about: 'About Loena',
  suites: 'Suites',
  reviews: 'Reviews',
  contact: 'Contact',
  
  // Additional navigation items
  gallery: 'Gallery',
  amenities: 'Amenities',
  booking: 'Booking',
  blog: 'Loena Journal',
  
  // Menu items
  menu: 'Menu',
  close: 'Close',
  
  // Language selector
  language: 'Language',
  english: 'English',
  greek: 'Greek',
};
